<template>
    <span
        v-if="!!betukod"
        class="forgalmi-prefix"
    >
        <span v-html="betukod" />
    </span>
</template>

<script>
export default {
    name: 'BnForgalmiBetukod',
    props: {
        betukod: {
            type: String,
            required: true,
        },
    },
};
</script>

<style scoped>
.forgalmi-prefix {
    width: 30px;
    min-height: 30px;
    display: inline-flex;
    justify-content: center;
    align-items: center;
    background: var(--v-secondary-base);
    color: #fff;
    font-size: 14px;
    font-weight: bold;
    border-radius: 4px;
    padding: 4px ;
}
</style>
